export default {
    title: 'Trees',
    'placeholder': 'Arvores Plantadas',
   
    'content1': `Lista de algumas das árvores plantadas no Vale Florido para o Projeto Mil Folhas:`,
    'content2': `(Página referente ao livro Árvores Brasileiras, H. Lorenzi/Plantarum)`,
    'content3': `https://www.plantarum.com.br/prod,idcategoria,206612,livros-em-portugues`,
    'content4': `Árvores Brasileiras`,

    'table1': `Árvores com características PIONEIRAS de acordo com clima, altitude, e solo da região:`,
    'col1': `Nome Popular`,
    'col2': ` Nome Científico`,
    'col3': `Família`,
    'col4': `Página`,
    'table2': `Árvores com características SECUNDÁRIAS INICIAIS de acordo com clima, altitude, e solo da região:`,
    'table3': `Árvores com características SECUNDÁRIAS TARDIAS de acordo com clima, altitude, e solo da região:`,
    'table4': `Árvores com características CLIMÁXICAS de acordo com clima, altitude, e solo da região:`

   
  };